module.exports = __webpack_public_path__ + "static/img/tr.39183b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tr.jpg
// module id = koSZ
// module chunks = 0